import axios from "axios";
import { getCookie } from "../utils/cookies";

export const BACKEND_URL = "https://api-career.indomobil.co.id/";


export const publicApiClient = axios.create({
    baseURL: BACKEND_URL,
});

const apiClient = axios.create({
    baseURL: BACKEND_URL,
});

apiClient.interceptors.request.use(
    (config) => {
        const token = getCookie("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: Runs AFTER a response. Checks for 401 errors.
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        // Check specifically for a 401 Unauthorized error
        if (error.response && error.response.status === 401) {
            const responseDataString = JSON.stringify(error.response.data);
            const isLoginError = responseDataString.includes("Email or password is wrong");
            if (!isLoginError) {
                console.error("Interceptor caught 401 Unauthorized. Logging out.");
                // Clear the expired token cookie to prevent login loops
                document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                // Clear Local Storage if user is kicked to LoginPage
                localStorage.clear();
                // Redirect to the login page
                window.location.href = "/login?reason=session_expired";
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;